import React from 'react';
import { CustomButton } from '@/components/ui/CustomButton';

const defaultIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_212_643)">
      <path
        d="M9.99999 13.3334V10.0001M9.99999 6.66675H10.0083M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
        stroke="#CBCDD6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_212_643">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export function SearchBar({
  value,
  id = 'search',
  onChange,
  onClick,
  backgroundColour = 'white',
  showButton = true,
  showButtonText = 'Search',
  icon = null,
  iconPosition = 'right-4',
  placeHolderPosition = 'pr-12',
  border = true,
  className = '',
  placeHolderClass = '',
  onKeyPress,
  tooltipMessage = 'Enter a keyword to search our lending criteria',
  placeHolderMessage = 'Search our criteria...',
}) {
  const resolvedIcon = icon || defaultIcon;

  return (
    <div className={`space-y-4 max-w-md md:flex md:space-y-0 md:space-x-4 ${className}`}>
      <div className="relative flex-1">
        <label htmlFor={id} className="sr-only">Search</label>
        <input
          id={id}
          type="text"
          placeholder={placeHolderMessage}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={onKeyPress}
          aria-label="Search blogs"
          className={`w-full px-4 py-3 rounded-lg ${border ? 'border-[#006EB7] border-2' : ''}
           bg-[${backgroundColour}] text-[#5B5D6B] ${placeHolderPosition} ${placeHolderClass}`}
        />
        <div className={`absolute ${iconPosition} top-1/2 -translate-y-1/2 w-5 h-5`}>
          <div className="relative inline-block">
            <div className="peer cursor-help">
              {React.cloneElement(resolvedIcon, {
                className: 'w-5 h-5',
              })}
            </div>
            {tooltipMessage && tooltipMessage.length > 0
            && <span className="absolute left-1/2 -translate-x-1/2 hidden peer-hover:block
             bg-black text-white text-sm rounded px-2 py-1 mb-2 whitespace-nowrap z-10
              before:content-[''] before:absolute before:top-full before:left-1/2
              before:-translate-x-1/2 before:border-4 before:border-transparent
              before:border-t-black"
            >
              {tooltipMessage}
            </span>
            }
          </div>
        </div>
      </div>
      {showButton && (
        <CustomButton variant="primarySmall" className="w-full md:w-auto" onClick={onClick}>
          {showButtonText}
        </CustomButton>
      )}
    </div>
  );
}
